import { useAppSelector } from 'tradera/state/hooks';
import type { Language } from 'tradera/state/language/types';
import {
    endpoints,
    getFavouriteSellersQueryParams
} from 'tradera/state/services/discover-api';
import { useRTKQuery } from 'tradera/state/services/hooks/use-rtk-query';

/**
 * Use this to leverage caching between components that rely on the same data,
 * since RTK Query caches on all parameters passed to the query.. If they differ
 * between two components, two requests will be made. At least for the start page that
 * is unnecessary.
 */
export const useFetchFavouriteSellers = ({
    skip,
    loadingTriggerInView
}: {
    skip: boolean;
    loadingTriggerInView?: boolean;
}) => {
    const shippingCountryCode = useAppSelector(
        (state) => state.shippingRegion.shippingCountry.countryCodeIso2
    ) as string;

    const userPreferredLanguage = useAppSelector(
        (state) => state.language.preferred
    ) as Language;
    const userLanguage = userPreferredLanguage.languageCodeIso2;
    const automaticTranslationPreferred = useAppSelector(
        (state) => state.language.automaticTranslationPreferred
    ) as boolean;

    const queryParams = getFavouriteSellersQueryParams({
        shippingCountryCode,
        userLanguage,
        automaticTranslationPreferred
    });

    return useRTKQuery({
        endpoint: endpoints.getFavouriteSellers,
        queryParams: queryParams,
        skip,
        isLoadingTriggerInView: loadingTriggerInView
    });
};
